import React from "react";
import { Handle, Position } from "@xyflow/react";
import { Card } from "@/components/ui/card";
import { Bot } from "lucide-react";

export default function AiConversationStartNode() {
  return (
    <Card className="min-w-50 border-primary">
      <div className="p-4">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-full bg-primary text-primary-foreground">
            <Bot className="h-5 w-5" />
          </div>
          <div>
            <div className="font-semibold">Conversation Start</div>
            <div className="text-xs text-muted-foreground">Caller connects</div>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Bottom} className="w-3 h-3" />
    </Card>
  );
}
